<template>
  <div class="fixed-right">
    <div class="fixed-list">
      <div v-if="!userInfo.isOrgwarehouse&&!userInfo.isRestaurant" class="fixed-item flex flex-col items-center justify-between"  @click="goPage('/main/personalCenter/collect')">
        <img src="@/assets/home/fixed-collect.png" class="fixed-item-icon" />
        <div class="fixed-item-title">我的收藏</div>
      </div>
      <div v-if="!userInfo.isSupplier" class="fixed-item flex flex-col items-center justify-between" @click="openManagerPage">
        <img src="@/assets/home/fixed-order.png" class="fixed-item-icon" />
        <div class="fixed-item-title">我的订单</div>
      </div>
      <div v-if="!userInfo.isSupplier"
        class="fixed-item flex flex-col items-center justify-between"
        @click="goPage('/main/personalCenter/cart')">
        <a-badge :count="cartCount">
          <img src="@/assets/home/fixed-cart.png" class="fixed-item-icon" />
        </a-badge>
        <div class="fixed-item-title">购物车</div>
      </div>
      <div class="fixed-item flex flex-col items-center justify-between"
        id="right-fixed-cart-icon" @click="goPage('/main/personalCenter/userInfo')">
        <img src="@/assets/home/fixed-my.png" class="fixed-item-icon" />
        <div class="fixed-item-title">我的</div>
      </div>
    </div>
    <div v-if="topShow" class="fixed-topping flex items-center justify-center mt-10" @click="clientTop">
      <img src="@/assets/home/icon-top.png" class="fixed-top-img" />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
const store = useStore()
const userInfo = computed(()=>store.state.user.userInfo) //ref(true)//;
const Token = computed(() => store.state.token?.token || '')
const router = useRouter()

const cartCount = ref(0)

watch(
  () => store.state.productsCart,
  newValue => {
    // console.log('newValue',newValue)
    let sum = 0
    if(newValue?.productsCart){
      newValue.productsCart.map((item, index) => {
        item?.productList.map(pro => {
          sum += pro.count
        })
      })
    }
    
    cartCount.value = sum?sum.toFixed(2):0
  },
  { immediate: true, deep: true }
)
// 回到顶部是否显示
const topShow = ref(false)

// 浏览器滚动
function windowScroll() {
  // 回到顶部按钮
  if (document.documentElement.scrollTop >= 600) {
    topShow.value = true
  } else {
    topShow.value = false
  }
}

function goPage(path) {
  if (path) {
    router.push(path)
  }
}
function openManagerPage() {
  console.log(store.state.user.userInfo.isCollege)
  if(!store.state.user.userInfo.isCollege){
    goPage('/main/personalCenter/order')
    return
  }
  let url = ''
  switch (process.env.NODE_ENV) {
    case 'development':
      url = 'https://test.rongdaufun.com/'
      break
    case 'production':
      url = 'https://www.rongdajicai.com/'
      if (location.host == 'test.rongdaufun.com') {
        url = 'https://test.rongdaufun.com/'
      }
      break
    default:
      break
  }
  // window.open(url)
  // 创建一个iframe
  const iframe = document.createElement('iframe')
  iframe.style.height = '0'
  iframe.style.border = 'none'
  // 先跳转到 switch-region.html 中转页，将 token 等信息带到新域名
  iframe.src = url+`spa/switch-region.html?Token=`+Token.value

  document.body.appendChild(iframe)

  // iframe加载，表示token已经写入到新域名中
  // 跳转到 ng 站点
  iframe.onload = () => {
    let timer = setTimeout(() => {
      // window.location.href = 'https://www.rongdajicai.com/sc-manager/'
      window.open('https://www.rongdajicai.com/sc-manager/')
      clearTimeout(timer)
    }, 1000)
  }

}

onMounted(() => {
  window.addEventListener('scroll', windowScroll, true)
  const barLeft = document.getElementById('right-fixed-cart-icon').getBoundingClientRect().x
  store.commit('SAVE_cartPosition', barLeft)
})
onBeforeUnmount(() => {
  window.removeEventListener('scroll', windowScroll, false)
})

// 回到顶部
function clientTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
</script>
<style lang="scss" scoped>
.fixed-right {
  width: 72px;
  min-height: 385px;
  position: fixed;
  right: 158px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;

  .fixed-list {
    background: #ffffff;
    box-shadow: 0px 0px 14px -2px rgba(36, 37, 39, 0.1);
    border-radius: 10px;
  }

  .fixed-item {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
    padding: 18px 0;
    border-bottom: 1px solid #e8e8e8;
    cursor: pointer;

    &:last-child {
      border-bottom: 0;
    }

    .fixed-item-icon {
      width: 24px;
      height: 24px;
    }

    .fixed-item-title {
      margin-top: 2px;
      line-height: 23px;
    }

    :deep(.ant-badge-count) {
      min-width: 15px;
      height: 15px;
      line-height: 15px;
      .ant-scroll-number-only {
        height: 15px;
        line-height: 15px;
      }
      .ant-scroll-number-only-unit {
        height: 15px;
        line-height: 15px;
      }
    }
  }
}

.fixed-topping {
  width: 72px;
  height: 32px;
  background: #ffffff;
  box-shadow: 0px 0px 14px -2px rgba(36, 37, 39, 0.1);
  border-radius: 10px;
  cursor: pointer;

  .fixed-top-img {
    width: 12px;
    height: 12px;
  }
}

@media (max-width: 1600px) {
  .fixed-right {
    right: 70px;
  }
}

@media (max-width: 1400px) {
  .fixed-right {
    right: 10px;
  }
}
@media (max-width: 1200px) {
  .fixed-right {
    right: 0px;
  }
}
</style>
